<template>
  <div>
    <div v-if="$store.getters['auth/isRole']('ROLE_AGENT') == true">
      <div class="main main--desktop">
        <div class="main__content">
          <Nav></Nav>
          <ProductFamilyList></ProductFamilyList>
          <router-view />
          <Footer></Footer>
        </div>
        <div class="main__sidebar sidebar">
          <div class="sidebar__btns">
            <router-link :to="{ name: 'OrderList' }" class="btn btn--orders">
              <img class="btn__picto" alt="" src="/static/img/pictos/commandebleuciel.svg">
              <span class="btn__text">Mes commandes</span>
            </router-link>
            <a href="" class="btn btn--cart">
              <img class="btn__picto" alt="" src="/static/img/pictos/panier.svg">
              <label>{{ total }}</label>
              <span class="btn__text">Mon panier</span>
            </a>
          </div>
          <Cart v-if="$store.getters['auth/isLoggedIn'] == true"></Cart>
        </div>
      </div>
    </div>
    <div v-else-if="$store.getters['auth/isRole']('ROLE_TECHNICIAN') == true">
      <div class="main main--mobile">
        <Nav></Nav>
        <Search></Search>
        <div class="main__content">
          <router-view />
        </div>
      </div>
      <Footer></Footer>
      <!-- <Scrolltop></Scrolltop> -->
    </div>
    <div
      v-else-if="$store.getters['auth/isRole']('ROLE_ADMIN') == true || $store.getters['auth/isRole']('ROLE_SUPER_ADMIN') == true">
      <Nav></Nav>
      <div class="main main--admin">
        <!-- <Menu></Menu> -->
        <div class="main__content">
          <router-view />
        </div>
      </div>
      <Footer class="footer--admin"></Footer>
    </div>
    <div v-else-if="$store.getters['auth/role'] == ''">
      <router-view />
    </div>
    <Loader></Loader>
  </div>
</template>

<script>

import Nav from "@/components/Global/Nav";
import Menu from "@/components/Global/Menu";
import Search from "@/components/Global/Search";
import Loader from "@/components/Global/Loader";
import Cart from "@/components/Cart/Cart";
import Footer from "@/components/Global/Footer";
import Scrolltop from "@/components/Global/Scrolltop";
import ProductFamilyList from "@/components/ProductFamily/ProductFamilyList";
import _ from 'lodash';

export default {
  name: "App",
  data() {
    return {
      version: process.env.VERSION,
      currentRoute: window.location.pathname,
    };
  },
  computed: {
    // Récupération du nombre de produits du panier
    total: function() {
      return this.$store.getters["order/getCartNbItems"];
    },
    ViewComponent() {
      return routes[this.currentRoute] || NotFound;
    }
  },
  mounted() {
    // Permet de relancer une requête au back pour récupérer le panier à jour
    this.$store.dispatch("order/getMyCart").then(function(){ });
  },
  created() {
    this.$store.dispatch("auth/refreshAuthorizations");
  },
  components: {
    Nav,
    Search,
    Menu,
    Loader,
    Cart,
    Footer,
    Scrolltop,
    ProductFamilyList,
  },
  render(h) {
    return h(this.ViewComponent);
  }
};
</script>

<style lang="scss" scoped>
@import "~vue-wysiwyg/dist/vueWysiwyg.css";
@import "~@/assets/scss/_colors.scss";


.main {
  width: 100%;

  &__content {
    width: 75%;
    margin-right: 25%;
  }

  &__sidebar {
    width: 25%;
    position: fixed;
    height: 100vh;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .sidebar {
    border-left: 1px solid $grisclair;

    &__btns {
      width: 100%;
      background-color: $grisclair;
      display: flex;
      height: 135px;
    }

    .btn {
      width: 50%;
      outline: none;
      border-radius: 0;

      &--cart {
        background-color: $color3;
        position: relative;

        .btn__text {
          color: white;
        }

        label {
          position: absolute;
          width: 35px;
          height: 35px;
          line-height: 35px;
          background: $rouge;
          border-radius: 50%;
          display: block;
          position: absolute;
          right: 50%;
          margin-right: -35px;
          top: 15px;
          font-family: 'ClanFFBlack';
          color: white;
          font-size: 14px;
        }
      }

      &--orders {
        background-color: white;

        .btn__text {
          color: $color3;
        }
      }

      &__text {
        text-transform: uppercase;
        font-family: 'ClanProBold';
        font-weight: normal;
        font-size: 12px;
        display: block;
        margin-top: 10px;
      }

      &__picto {
        width: 60px;
        margin-top: 20px;
      }
    }
  }

  &--desktop {
    .main__content {
      margin-top: 215px;
    }
  }

  &--mobile {
    .main__content {
      width: 100%;
    }
  }

  &--admin {
    display: block;

    .main__content {
      width: 100%;
      margin-right: 0;
      margin-top: 0;
      padding: 0;
    }
  }
}

@media screen and (max-width: 1680px) {
  .main__content {
    width: calc(100% - 415px);
    margin-right: 415px;
  }

  .main__sidebar {
    width: 415px;
  }

  .main {
    &--mobile {
      .main__content {
        width: 100%;
        margin-right: 0;
      }
    }

    &--admin {
      .main__content {
        width: 100%;
        margin-right: 0;
      }
    }
  }
}</style>


<style lang="scss">@import "~@/assets/scss/_fonts.scss";
@import "/static/fontawesome/css/all.min.css";</style>



// WEBPACK FOOTER //
// src/App.vue